import { ConnectEmailMethod, MasterTranslation } from '@/constants';
import { useGlobalState, useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { ConnectGoogleButton } from '@/modules/pmt/components/ConnectGoogleButton';
import { Divider } from '@/modules/pmt/components/Divider';
import { TrackingWidget } from '@/modules/pmt/components/TrackingWidget';
import { useMyParcelsContext } from '@/modules/pmt/context';
import { useTrackSignEvents } from '@/utils/GTM/useTrackSignEvents.hook';
import type { FC, JSX } from 'react';
import { SyncInProgressBanner } from '../../../SyncInProgressBanner';
import { SyncInProgressBannerWrapper } from '../../../SyncInProgressBanner/SyncInProgressBanner.styles';
import { MainText, NotLoggedInContent, SubText } from '../../DefaultTrackingContainer.styles';

interface ILoggedInConnectedESBannerProps {
  squareAd?: JSX.Element;
  searchShipments: (trackingIds: string[]) => void;
}

export const LoggedInConnectedESBanner: FC<ILoggedInConnectedESBannerProps> = ({ squareAd, searchShipments }) => {
  const { trackingTranslation } = useMyParcelsContext();
  const { t } = useGlobalState();
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);
  const track = useTrackSignEvents();

  const mainText = isDesktopPMT ? trackingTranslation.mainTextDesktop : trackingTranslation.mainTextMobile;

  const subText = isDesktopPMT ? trackingTranslation.subTextDesktop : trackingTranslation.subTextMobile;

  return (
    <>
      {/* TW input + Add parcels button */}
      <TrackingWidget handleSubmit={searchShipments} />
      <Divider>{t(MasterTranslation.Or)}</Divider>
      <ConnectGoogleButton
        buttonText={t(MasterTranslation.TrackingWidgetConnectGmail)}
        onSuccess={({ emsFirstGrant }) =>
          track.connectEmailSuccess({ method: ConnectEmailMethod.TrackingWidget, emsFirstGrant })
        }
      />
      {!isDesktopPMT && (
        <SyncInProgressBannerWrapper>
          <SyncInProgressBanner />
        </SyncInProgressBannerWrapper>
      )}
      {squareAd}
      <NotLoggedInContent>
        <img
          src='/images/tracking-default-image.svg'
          alt='tracking-default-image'
          width={isDesktopPMT ? 290 : 236}
          height={isDesktopPMT ? 160 : 130}
          style={{
            objectFit: 'contain',
          }}
        />
        <MainText>{mainText}</MainText>
        <SubText>{subText}</SubText>
      </NotLoggedInContent>
    </>
  );
};
